import { message } from 'antd';

import { call, put, takeLatest, all, fork } from 'redux-saga/effects'
import { CHANGE_PASSWORD, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_ERROR, CHANGE_PASSWORD_SIGNOUT } from "../actions/changePasswordActions";
import { SIGNOUT_USER_SUCCESS } from "../../constants/ActionTypes";
import { HIDE_MODAL, SUBMIT_START, SUBMIT_ERROR, SUBMIT_STOP } from "../actions/userModalActions";
import { changePasswordAPI } from "../../services/users-service";

function* changePassword({ user }) {
    try {
        yield put({ type: SUBMIT_START })
        const response = yield call(changePasswordAPI, user);
        if (response.success) {
            yield put({ type: CHANGE_PASSWORD_SUCCESS, user: response.data })
            yield put({ type: HIDE_MODAL })
            message.success('Your password changed successfully.');
            yield put({ type: CHANGE_PASSWORD_SIGNOUT });
            yield put({ type: SIGNOUT_USER_SUCCESS });
            yield put({ type: SUBMIT_STOP });
        } else {
            yield put({ type: CHANGE_PASSWORD_ERROR, error: response.data })
            yield put({ type: SUBMIT_ERROR })
            message.error(response.data);
        }
    } catch (error) {
        yield put({ type: CHANGE_PASSWORD_ERROR, error })
        yield put({ type: SUBMIT_ERROR })
        message.error('Error occurred while changing password!');
    }
}


function* changePasswordWatcher() {
    yield takeLatest(CHANGE_PASSWORD, changePassword)
}


export default function* rootSaga() {
    yield all([changePasswordWatcher()]);
}
